<template>
  <div @mouseover="hoverall = true" @mouseleave="hoverall = false">
    <template v-for="(snackbar, index) in barlist">
      <v-slide-y-reverse-transition :key="snackbar.id">
        <v-snackbar v-model="snackbar.id" :color="snackbar.color" timeout="-1" class="globalsnackbar"
          :style="'margin-bottom: ' + (((index) * (hoverall ? 68 : (barlist.length < 4 ? 70 : 10))) + 30) + 'px !important;'"
          height="20">
          <v-container class="pa-0 d-flex align-center justify-space-between inheritwidth" fluid>
            <v-list-item class="px-0 liwidth">
              <v-list-item-icon
                class="ma-0 ml-2 mr-4 d-flex flex-column align-center justify-center align-self-stretch">
                <v-icon
                  :size="(snackbar.errorlogg && snackbar.errorlogg.Response && snackbar.errorlogg.Response.Code) ? 27 : 30"
                  v-text="snackbar.icon ? snackbar.icon : 'mdi-alert'" />
                  <!-- CLUTTER
                    <p v-if="snackbar.errorlogg && snackbar.errorlogg.Response && snackbar.errorlogg.Response.Code" style="color: white;
                    opacity: 0.8;" class="ma-0">{{ snackbar.errorlogg.Response.Code }}</p>
                    -->
              </v-list-item-icon>
              <v-list-item-content class="py-0">
                <v-list-item-title class="textcontainer ma-0 pa-0" style="font-size: 20px !important;">
                  <p class="nowrapheader my-0">{{ snackbar.text }}</p>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <p style="font-size: 18px; 
                  display: -webkit-box;
                  max-width: 100%;
                  -webkit-line-clamp: 1 /*2*/;
                  line-clamp: 1 /*2*/;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  white-space: no-wrap /*pre-wrap*/;
                  color: white;
                  opacity: 0.8;" class="my-0">
                    {{ snackbar.subtext ? JSON.stringify(snackbar.subtext).substring(1, snackbar.subtext.length + 1) :
                      '' }}</p>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="snackbar.color === 'error'" class="ma-0">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="white" v-bind="attrs" v-on="on" icon class="ml-2" @click="createTicket(snackbar)">
                      <v-icon>mdi-email-fast</v-icon>
                    </v-btn>
                  </template>
                  <span>Generate support ticket</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
            <v-list-item-action class="ma-0">
              <v-hover v-slot="{ hover }">
                <v-btn color="white" icon class="ml-0" @click="closeDialog(snackbar.id)">
                  <v-progress-circular :value="snackbar.progress" :width="2" :rotate="270" color="white">
                    <v-icon v-text="!hover && (hoverall || selectedSnack) ? 'mdi-pause' : 'mdi-close'" />
                  </v-progress-circular>
                </v-btn>
              </v-hover>
            </v-list-item-action>
          </v-container>
        </v-snackbar>
      </v-slide-y-reverse-transition>
    </template>
    <ticket-dialog :externaltrigger="ticketTrigger" :externalCloseTrigger="ticketCloseTrigger"
      :errorlogg="selectedSnack ? selectedSnack.errorlogg : null" :isLoggedIn="isLoggedIn" @close="closeAfterTicket()">
    </ticket-dialog>
  </div>
</template>


<script>
import TicketDialog from "@/components/Dialogs/TicketDialog.vue";

export default {
  name: "GlobalSnackbar",
  components: { TicketDialog },
  props: {
    isLoggedIn: Boolean,
  },

  data() {
    return {
      hoverall: false,
      ticketTrigger: 0,
      ticketCloseTrigger: 0,
      selectedSnack: null,
    };
  },

  mounted() { },

  methods: {
    syncProgress(expected, snackbar) {
      setTimeout(() => {
        if (snackbar.currentTime != expected) {
          return false;
        } else {
          if (this.hoverall || this.selectedSnack) {
            this.syncProgress(expected, snackbar);
          } else {
            snackbar.currentTime += 1000;
            const percent = 100 - (100 * snackbar.currentTime) / snackbar.timeout;
            this.setProgress(snackbar.id, percent);

            if (snackbar.timeout < snackbar.currentTime) {
              this.closeDialog(snackbar.id);
            } else {
              const currentExpectation = snackbar.currentTime.valueOf();
              this.syncProgress(currentExpectation, snackbar);
            }
          }
        }
      }, 1000);
    },

    createTicket(snackbar) {
      this.hover = true;
      this.selectedSnack = snackbar;
      this.ticketTrigger++;
    },

    setProgress(id, percent) {
      this.$store.dispatch("triggerevents/setSnackbarProgress", { id: id, progress: percent });
    },

    closeAfterTicket() {
      this.selectedSnack = null;
    },

    closeDialog(id) {
      this.$store.dispatch("triggerevents/closeSnackbar", id);
    },
  },

  computed: {
    trigger() {
      return this.$store.getters["triggerevents/GlobalSnackBarTrigger"];
    },

    barlist() {
      return this.$store.getters["triggerevents/ActiveSnackbars"];
    },
  },

  watch: {
    trigger: function () {
      var snack = this.barlist[this.barlist.length - 1];

      this.syncProgress(0, snack);
    },
  },
};
</script>


<style lang="scss">
.globalsnackbar {
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  z-index: 202 !important;
}

.v-snack__content {
  padding: 8px !important;
  max-width: inherit;
  min-width: inherit;
}

.v-progress-circular__underlay {
  stroke: rgba(253, 253, 253, 0.076);
}

.inheritwidth {
  max-width: inherit;
  min-width: inherit;
}

.liwidth {
  max-width: calc(100% - 44px);
  min-width: calc(100% - 44px);
}
</style>